// Temporary local types until models are properly organized

export type PresenceTypeSingle = "permesso" | "104";
export type PresenceTypeRange =
  | "malattia"
  | "ferie"
  | "maternità"
  | "festività"
  | "chiusura ufficio";
export type PresenceType = PresenceTypeRange | PresenceTypeSingle;
export type PresenceTableItem = {
  pk: string;
  sk: string;
  lastUpdate?: number;
};
export type DateString = `${number}-${number}-${number}`; // YYYY-MM-DD
export type MonthString = `${number}-${number}`; // YYYY-MM
export type PresenceDay = Omit<PresenceTableItem, "sk"> & {
  sk: `presenceDay#${DateString}`;
  date: string;
  notes?: string;
  reason: PresenceType;
};

export type PresenceSingle = PresenceDay & {
  hours?: number;
  reason: PresenceTypeSingle;
};
export type PresenceRange = PresenceDay & {
  startDate: string;
  endDate: string;

  reason: PresenceTypeRange;
  date?: string;
  hours?: number;
  createdAt?: unknown;
  updatedAt?: number;
  /** Chiavi S3 dei certificati medici (solo per malattia) */
  attachments?: string[];
};
export type Presence = PresenceSingle | PresenceRange;

export type PresenceMonth = PresenceTableItem & {
  sk: `presenceMonth#${MonthString}`;
  year: number;
  month: number;
  days: PresenceDay[];
  message?: string;
  attachments?: string[];
  withNotaSpese?: boolean;
  sendDate?: number;
  [key: string]: unknown;
};

export type Expense = PresenceTableItem & {
  sk: `expense#${DateString}#${string}`;
  date: string;
  type: "expense";
  cost: number;
  description?: string;
  attachments?: string[];
};

export type Mileage = PresenceTableItem & {
  sk: `mileage#${DateString}#${string}`;
  date: string;
  type: "mileage";
  distance: number;
  destination: string;
  euroPerKm: number;
  refound: number;
  vehicleSk?: string;
  client?: string;
};

export type CalendarItem = Presence | Expense | Mileage;

export const DAY_STRING_FORMAT = "yyyy-MM-dd" as const;
export const MONTH_STRING_FORMAT = "yyyy-MM" as const;

// Alternative exports with old names for backward compatibility
export const DayStringFormat = DAY_STRING_FORMAT;
export const MonthStringFormat = MONTH_STRING_FORMAT;
